module.exports = __webpack_public_path__ + "img/liushui (1).a320eca4.png";